import { render, staticRenderFns } from "./FilterValueBadge.vue?vue&type=template&id=9d3e2a10&"
import script from "./FilterValueBadge.vue?vue&type=script&lang=ts&"
export * from "./FilterValueBadge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports